import {ALL_PRODUCTS} from "./products/index";
import {ALL_PRODUCT, DEFAULT_PRODUCT, DEFAULT_PRODUCTS_MAPPING} from "./constants";
import {EMAIL_LAYOUTS} from "./templateManifest";

export const PRODUCTS = [...ALL_PRODUCTS].sort((a, b) => a.label.localeCompare(b.label));

export const CONTENT_TYPES = [
  {
    label: "General",
    value: "general",
  },
  {
    label: "Newsletter",
    value: "newsletter",
  },
  {
    label: "Java Annotated",
    value: "java-annotated",
  },
  {
    label: "Workshop",
    value: "workshop",
  },
  {
    label: "Hackathon",
    value: "hackathon",
  },
  {
    label: "Webinar",
    value: "webinar",
  },
  {
    label: "If/Else",
    value: "if-else",
    altLabel: "IF/ELSE INSIGHTS",
  },
  {
    label: "Blueprint++",
    value: "blueprint",
    altLabel: "BLUEPRINT++",
  },
  {
    label: "Jam Event",
    value: "jam-event",
  },
  {
    label: "PHP Annotated",
    value: "php-annotated",
  },
  {
    label: "New",
    value: "new",
  },
  {
    label: "QR code",
    value: "qrcode",
  },
  // University Programs specific content types
  {label: "CSAI", value: "csai"},
  {label: "SDT", value: "sdt"},
  // Releases channel specific content types
  {label: "Release", value: "release"},
  {label: "EAP", value: "eap"},
  {label: "Beta", value: "beta"},
  {label: "RC", value: "rc"},
  {label: "Action", value: "action"},
  // Ads channel
  {label: "AI", value: "ai"},
  {label: "DevEco", value: "deveco"},
  {label: "Google Display Network", value: "google-display-network"},
];

export const GENERAL_TYPE = {
  label: "General",
  value: "general",
};
export const CHANNELS = [
  {
    label: "Social Media & Blog",
    value: "social",
    visible: true,
    // The offered layouts are an enumerated list (data/layoutPolicy.js), not
    // this count — kept in sync for anyone reading this file for "how many
    // layouts does Social have" (layout 7 retired 2026-10-12).
    layoutsNumber: 5,
    types: [
      {
        label: "General",
        value: "general",
        products: {
          JB: "c367865d",
          // JetBrains Air is one offering that two channels list. Its data —
          // templates, backgrounds, default scenes — stays under its home
          // scope (src/data/offering.ts), so this entry adds a way in, not a
          // second copy. The hash is empty for the same reason the Releases
          // entry's is: Air owns no legacy scene.
          AIR: "",
          JBD: "",
          KM: "",
          EXP: "",
          GDV: "",
          IDEs: "",
          AMP: "",
          CPPT: "",
          DN: "",
          IS: "",
          EDU: "",
          IJ: "23e045c4",
          AI: "",
          ST: "",
          AS: "",
          CC: "",
          CL: "",
          CWM: "",
          DBAO: "8351a92d",
          DG: "",
          DL: "",
          DC: "",
          DM: "",
          DS: "",
          DT: "",
          GZ: "",
          HB: "",
          JN: "",
          MP: "",
          ML: "",
          MPS: "",
          KG: "",
          KT: "",
          KTR: "",
          GW: "",
          DP: "",
          FL: "",
          GO: "",
          PC: "",
          PCD: "",
          PS: "",
          QD: "",
          RM: "",
          RR: "",
          RS: "",
          RD: "",
          TC: "",
          TB: "",
          RScpp: "",
          WS: "",
          CMP: "",
          UNI: "",
          YT: "",
        },
      },
      {
        label: "CSAI",
        value: "csai",
        products: {UNI: ""},
      },
      {
        label: "SDT",
        value: "sdt",
        products: {UNI: ""},
      },
      {
        label: "Newsletter",
        value: "newsletter",
        defaultLayout: 5,
        products: {
          DN: "229f7f17",
          JB: "02dffe13",
          MP: "fcb47c1f",
          TC: "a39cfbdd",
        },
      },
      {
        label: "Java Annotated",
        value: "java-annotated",
        defaultLayout: 5,
        products: {IJ: "7938f829"},
      },
      // {
      //   label: "Release",
      //   value: "release",
      //   products: ["IJ", "AMP", "CLN", "EDU", "RF"]
      // },
      // {
      //   label: "EAP",
      //   value: "eap",
      //   products: ["IJ", "CLN", "RF"]
      // },
      // {
      //   label: "Bug-fix",
      //   value: "bug-fix",
      //   products: ["CLN", "RF"]
      // },
      // {
      //   label: "Roadmap",
      //   value: "roadmap",
      //   products: ["CLN", "CPPT", "EDU", "RF"]
      // },
      {
        label: "Workshop",
        value: "workshop",
        products: {IH: ""},
      },
      {
        label: "Hackathon",
        value: "hackathon",
        products: {IH: ""},
      },
      {
        label: "Webinar",
        value: "webinar",
        products: {IH: ""},
      },
      {
        label: "Jam Event",
        value: "jam-event",
        products: {IH: ""},
      },
      // {
      //   label: "Tips&Tricks",
      //   value: "tips-tricks",
      //   products: ["CPPT", "RF"]
      // },
      // {
      //   label: "Events",
      //   value: "events",
      //   products: ["CPPT"]
      // },
      // {
      //   label: "Interviews",
      //   value: "interviews",
      //   products: ["CPPT", "EDU"]
      // },
      // {
      //   label: "News",
      //   value: "news",
      //   products: ["EDU"]
      // },
      // {
      //   label: "JB Academy",
      //   value: "jb-academy",
      //   products: ["EDU"]
      // },
      // {
      //   label: "Edu IDEs",
      //   value: "edu-ides",
      //   products: ["EDU"]
      // },
      // {
      //   label: "Learning Courses",
      //   value: "learning-courses",
      //   products: ["EDU"]
      // },
      // {
      //   label: "Tools for Teaching",
      //   value: "tools-for-teaching",
      //   products: ["EDU"]
      // },
      {
        label: "PHP Annotated",
        value: "php-annotated",
        defaultLayout: 5,
        products: {PS: "c3d7d8d1"},
      },
      // {label: "New", value: "new", products: {EDU: ""}},
    ],
  },
  {
    label: "Internal",
    value: "internal",
    visible: true,
    layoutsNumber: 6,
    types: [
      {
        label: "Workshop",
        value: "workshop",
        products: {IH: ""},
      },
      {
        label: "Hackathon",
        value: "hackathon",
        products: {IH: ""},
      },
      {
        label: "Webinar",
        value: "webinar",
        products: {IH: ""},
      },
      {
        label: "Jam Event",
        value: "jam-event",
        products: {IH: ""},
      },
    ],
  },
  {
    label: "Livestream",
    value: "livestream",
    visible: true,
    types: [
      {
        label: "General",
        value: "general",
        products: {
          GDV: "",
          IJ: "",
          JB: "",
          JN: "",
          DN: "",
          RD: "",
          RR: "",
          RS: "",
          WS: "",
        },
      },
    ],
    layoutsNumber: 0,
  },
  {
    label: "Email",
    value: "email",
    visible: true,
    types: [
      {
        label: "General",
        value: "general",
        products: {
          AMP: "",
          KM: "",
          EXP: "",
          GDV: "",
          AS: "",
          CC: "",
          CL: "",
          CMP: "",
          CWM: "",
          DBAO: "02981c8f",
          DC: "",
          DG: "",
          DL: "",
          DM: "",
          DN: "",
          DP: "",
          DS: "",
          DT: "",
          EDU: "",
          FL: "",
          GO: "",
          GW: "",
          GZ: "",
          HB: "",
          IJ: "",
          IS: "",
          JB: "",
          JBD: "",
          JN: "",
          AI: "",
          IDEs: "",
          KG: "",
          KT: "",
          KTR: "",
          ML: "",
          MP: "",
          MPS: "",
          PC: "",
          PCD: "",
          PS: "",
          QD: "",
          RD: "",
          RM: "",
          RR: "",
          RS: "",
          RScpp: "",
          ST: "",
          TB: "",
          TC: "",
          WS: "",
          YT: "",
        },
      },
    ],
    // The banners name their layouts in templateManifest.ts (EMAIL_MEMBERSHIPS).
    layoutsNumber: EMAIL_LAYOUTS.length,
  },
  {
    label: "Voucher",
    value: "print",
    visible: true,
    layoutsNumber: 1,
    types: [
      {
        label: "General",
        value: "general",
        products: {EDU: "52f72f74"},
      },
    ],
  },
  {
    label: "Partners",
    value: "partners",
    layoutsNumber: 4,
    visible: false,
    types: [
      {
        label: "General",
        value: "general",
        products: {JB: ""},
      },
    ],
  },
  {
    label: "Landing Page",
    value: "landingpage",
    visible: true,
    layoutsNumber: 4,
    types: [
      {
        label: "General",
        value: "general",
        products: {
          JB: "",
          JBD: "",
          KM: "",
          EXP: "",
          GDV: "",
          IDEs: "",
          AMP: "",
          DN: "",
          IS: "",
          EDU: "",
          IJ: "",
          AI: "",
          ST: "",
          AS: "",
          CL: "",
          CWM: "",
          DBAO: "2c1ec86d",
          DG: "",
          DL: "",
          DC: "",
          DM: "",
          DS: "",
          DT: "",
          GZ: "",
          HB: "",
          JN: "",
          MP: "",
          ML: "",
          MPS: "",
          KG: "",
          KT: "",
          KTR: "",
          GW: "",
          DP: "",
          FL: "",
          GO: "",
          PC: "",
          PCD: "",
          PS: "",
          QD: "",
          RM: "",
          RR: "",
          RS: "",
          RD: "",
          TC: "",
          TB: "",
          RScpp: "",
          WS: "",
          CMP: "",
          YT: "",
        },
      },
    ],
  },
  {
    label: "Events",
    value: "events",
    layoutsNumber: 4,
    visible: true,
    types: [
      {
        label: "QR code",
        value: "qrcode",
        products: {
          JB: "",
          GDV: "",
          IDEs: "",
          AMP: "",
          DN: "",
          IS: "",
          EDU: "",
          IJ: "",
          AI: "",
          ST: "",
          AS: "",
          CL: "",
          CWM: "",
          DG: "",
          DL: "",
          DC: "",
          DM: "",
          DS: "",
          DT: "",
          GZ: "",
          HB: "",
          MP: "",
          MPS: "",
          KT: "",
          KTR: "",
          GW: "",
          DP: "",
          FL: "",
          GO: "",
          PC: "",
          PS: "",
          QD: "",
          RM: "",
          RR: "",
          RS: "",
          RD: "",
          TC: "",
          TB: "",
          RScpp: "",
          WS: "",
          CMP: "",
          YT: "",
        },
      },
    ],
    layoutsConfig: {
      1: ["QRcodeIPad", "QRcodeFullHD"],
      2: ["QRcodeIPad", "QRcodeFullHD"],
      3: ["QRcodeIPad", "QRcodeFullHD"],
      4: ["QRcodeA4", "QRcodePrint"],
    },
  },
  {
    label: "Releases",
    value: "releases",
    visible: true,
    // The types below are release stages, not content formats: the product a
    // banner is for and the stage it announces are independent choices. The
    // Product dropdown therefore offers the whole channel here — see
    // productCodesForSelector.
    typesAreStages: true,
    layoutsNumber: 5,
    types: [
      {
        label: "Release",
        value: "release",
        defaults: {
          // all products
          "*": {
            "social-media": {
              default: "df00d103",
              backgrounds: {2: "ce190b40"},
            },
            splash: "",
            "whats-new": "",
            emails: "",
            wallpapers: "",
            webpreview: "",
            screenshots: {
              default: "",
              layouts: {20: ""},
              backgrounds: {1: "59b74260"},
            },
          },
        },
        products: {
          IJ: {
            sceneId: "c368bb78",
            sets: {
              "whats-new": "d4055eb5",
              screenshots: "98538151",
              "social-media": {
                layout: {
                  1: "e34887de",
                  3: "9c51f5b6",
                },
              },
            },
          },
          IDEs: {
            sceneId: "",
          },
          DNT: {
            sceneId: "c3f553e6",
            sets: {
              "whats-new": "",
              screenshots: "",
              "social-media": {
                layout: {
                  3: "d7db1841",
                },
                background: {1: "34c866ac", 2: "72ee1176"},
              },
            },
          },
          DU: {
            sceneId: "ee3d1603",
            sets: {
              "social-media": {
                layout: {3: "d2953439"},
              },
            },
          },
          CL: {
            sceneId: "a195047b",
            sets: {
              "social-media": {
                layout: {3: "a8e803da"},
              },
            },
          },
          CLT: {
            sceneId: "024c12d1",
            sets: {
              "social-media": {
                layout: {3: "192a158d"},
                background: {1: "25f66d80"},
              },
            },
          },
          CMP: {
            sceneId: "9dbca261",
            sets: {
              "social-media": "9dbca261",
            },
          },
          CWM: {
            sceneId: "d88ff002",
            sets: {
              "social-media": {
                layout: {3: "e8a5cf7c"},
              },
            },
          },
          DG: {
            sceneId: "1f12b7eb",
            sets: {
              "social-media": {
                layout: {3: "f9df1441"},
              },
            },
          },
          DL: {
            sceneId: "1f4bdf34",
            sets: {
              "social-media": {
                layout: {3: "6bcaa126"},
              },
            },
          },
          DC: {
            sceneId: "515b6149",
            sets: {
              "social-media": {
                layout: {3: "81eb25fe"},
              },
            },
          },
          DM: {
            sceneId: "7c6180c8",
            sets: {
              "social-media": {
                layout: {3: "2af2a148"},
              },
            },
          },
          DS: {
            sceneId: "e8936f3d",
            sets: {
              "social-media": {
                layout: {3: "8e7af88e"},
              },
            },
          },
          DT: {
            sceneId: "04ce6a75",
            sets: {
              "social-media": {
                layout: {3: "7c8638f7"},
              },
            },
          },
          MPS: {
            sceneId: "27867f63",
            sets: {
              "social-media": {
                layout: {3: "2eac24e3"},
              },
            },
          },
          DP: {
            sceneId: "a76776fd",
            sets: {
              "social-media": {
                layout: {3: "d36ede7f"},
              },
            },
          },
          EXP: {
            sceneId: "cae48ec7",
            sets: {
              "social-media": "cae48ec7",
            },
          },

          GO: {
            sceneId: "6f8a2058",
            sets: {
              "social-media": {
                layout: {3: "7b8dcdb9"},
              },
            },
          },
          KM: {
            sceneId: "99f07809",
            sets: {
              "social-media": "99f07809",
            },
          },
          KT: {
            sceneId: "69e67e54",
            sets: {
              "social-media": "69e67e54",
            },
          },
          KTR: {
            sceneId: "d5defb36",
            sets: {
              "social-media": "d5defb36",
            },
          },

          PC: {
            sceneId: "b4ae0248",
            sets: {
              "social-media": {
                layout: {3: "598b74e1"},
              },
            },
          },

          PCD: {
            sceneId: "0c0d33e0",
            sets: {
              "social-media": {
                layout: {3: "89aacbf8"},
              },
            },
          },
          PS: {
            sceneId: "fe75b309",
            sets: {
              "social-media": {
                layout: {3: "903c6412"},
              },
            },
          },
          RM: {
            sceneId: "28255e5b",
            sets: {
              "social-media": {
                layout: {3: "5812cb90"},
              },
            },
          },
          RR: {
            sceneId: "063422c9",
            sets: {
              "social-media": {
                layout: {3: "cf75a76c"},
              },
            },
          },
          RS: {
            sceneId: "fa748f1c",
            sets: {
              "social-media": {
                layout: {3: "7f2ffd2d"},
              },
            },
          },
          RD: {
            sceneId: "a5708b8d",
            sets: {
              "social-media": {
                layout: {3: "b754b715"},
              },
            },
          },
          RScpp: {
            sceneId: "be763189",
            sets: {
              "social-media": {
                layout: {3: "f9d80ccd"},
              },
            },
          },
          REM: {
            sceneId: "1a8e0ea6",
            sets: {
              "social-media": {
                layout: {3: "d169209d"},
              },
            },
          },
          WS: {
            sceneId: "01ddae13",
            sets: {
              "social-media": {
                layout: {3: "f5afbc60"},
              },
            },
          },
          // JetBrains Air ships in this channel only, and only at this stage —
          // a single stage means the toolbar hides the Stage selector. It owns
          // no legacy scene hashes: its defaults come from the `default_scenes`
          // overrides in the backend, and until an admin saves one the `"*"`
          // cascade above applies.
          AIR: {
            sceneId: "",
          },
        },
      },
      {
        label: "EAP",
        value: "eap",
        products: {
          IJ: "e1c819ab",
          CL: "9da9e82c",
          CLT: "f81ce5e9",
          CWM: "ec3dbd5b",
          DG: "ca7b84e6",
          DL: "a4c8d603",
          DC: "1c29b31f",
          DM: "f1451f7b",
          DS: "838beadc",
          DT: "e8d9a6d8",
          MPS: "25ac43b9",
          DP: "e0c68e3c",
          GO: "fc89244d",
          PC: "de23e1d4",
          PCD: "11292ccb",
          PS: "ee49d716",
          RM: "329633f7",
          REM: "097c93d0",
          RR: "4e36aefb",
          RS: "99b0469c",
          RD: "d348ab2e",
          RScpp: "0df29adc",
          WS: "dce7fe39",
        },
      },
      {
        label: "Beta",
        value: "beta",
        products: {
          IJ: "06d1bfad",
          CL: "",
          GO: "",
          PC: "",
          PS: "",
          RM: "",
        },
      },
      {
        label: "RC",
        value: "rc",
        products: {
          // JB: "",
          // KM: "",
          // EXP: "",
          // GDV: "",
          // IDEs: "",
          // AMP: "",
          // CPPT: "",
          // IS: "",
          // EDU: "",
          // IJ: "",
          // AI: "",
          // ST: "",
          // AS: "",
          // CC: "",
          // CL: "",
          // CWM: "",
          // DG: "",
          // DL: "",
          DC: "668cdef8",
          DM: "0e09aebf",
          // DS: "",
          DT: "3beed21c",
          // GZ: "",
          // HB: "",
          // JN: "",
          // MP: "",
          // MPS: "",
          // KT: "",
          // KTR: "",
          // GW: "",
          DP: "58d08b76",
          // FL: "",
          // GO: "",
          // PC: "",
          // PCD: "",
          // PS: "",
          // QD: "",
          // RM: "",
          // RR: "",
          // RS: "",
          RD: "119b77ca",
          // TC: "",
          // TB: "",
          RScpp: "a0399070",
          // WS: "",
          // CMP: "",
          // YT: "",
        },
      },

      //
      // {
      //   label: "Action",
      //   value: "action",
      //   products: {
      //     JB: "",
      //     KM: "",
      //     EXP: "",
      //     GDV: "",
      //     IDEs: "",
      //     AMP: "",
      //     CPPT: "",
      //     DN: "",
      //     IS: "",
      //     EDU: "",
      //     IJ: "",
      //     AI: "",
      //     ST: "",
      //     AS: "",
      //     CC: "",
      //     CL: "",
      //     CWM: "",
      //     DG: "",
      //     DL: "",
      //     DC: "",
      //     DM: "",
      //     DS: "",
      //     DT: "",
      //     GZ: "",
      //     HB: "",
      //     JN: "",
      //     MP: "",
      //     MPS: "",
      //     KG: "",
      //     KT: "",
      //     KTR: "",
      //     GW: "",
      //     DP: "",
      //     FL: "",
      //     GO: "",
      //     PC: "",
      //     PCD: "",
      //     PS: "",
      //     QD: "",
      //     RM: "",
      //     RR: "",
      //     RS: "",
      //     RD: "",
      //     TC: "",
      //     TB: "",
      //     RScpp: "",
      //     WS: "",
      //     CMP: "",
      //     YT: "",
      //   },
      // },
    ],
  },
  {
    label: "Webinar",
    value: "webinar",
    visible: false,
    types: [
      {
        label: "If/Else",
        value: "if-else",
        altLabel: "IF/ELSE INSIGHTS",
        products: {
          JB: "7171dcc6",
        },
      },
      {
        label: "Blueprint",
        value: "blueprint",
        altLabel: "BLUEPRINT++",
        products: {
          JB: "88f51d46",
        },
      },
    ],
    layoutsNumber: 0,
  },
  {
    label: "Ads",
    value: "ads",
    visible: true,
    layoutsNumber: 1,
    types: [
      {
        label: "AI",
        value: "ai",
        products: {
          JB: "",
        },
      },
      {
        label: "DevEco",
        value: "deveco",
        products: {
          JB: "",
        },
      },
      {
        // Product list mirrors Social's "general" type so the Ads product
        // selector on this content type matches Social (default JB). No
        // default scene IDs yet — every value is empty.
        label: "Google Display Network",
        value: "google-display-network",
        products: {
          JB: "",
          JBD: "",
          KM: "",
          EXP: "",
          GDV: "",
          IDEs: "",
          AMP: "",
          CPPT: "",
          DN: "",
          IS: "",
          EDU: "",
          IJ: "",
          AI: "",
          ST: "",
          AS: "",
          CC: "",
          CL: "",
          CWM: "",
          DBAO: "",
          DG: "",
          DL: "",
          DC: "",
          DM: "",
          DS: "",
          DT: "",
          GZ: "",
          HB: "",
          JN: "",
          MP: "",
          ML: "",
          MPS: "",
          KG: "",
          KT: "",
          KTR: "",
          GW: "",
          DP: "",
          FL: "",
          GO: "",
          PC: "",
          PCD: "",
          PS: "",
          QD: "",
          RM: "",
          RR: "",
          RS: "",
          RD: "",
          TC: "",
          TB: "",
          RScpp: "",
          WS: "",
          CMP: "",
          UNI: "",
          YT: "",
        },
      },
    ],
  },
  {
    label: "Video",
    value: "video",
    visible: true,
    layoutsNumber: 4,
    types: [
      {
        label: "General",
        value: "general",
        products: {
          JB: "a6bec725",
          CL: "694460bb",
          DC: "ef978caa",
          DG: "4793e19d",
          DL: "c567e500",
          DM: "e473eb0c",
          DN: "",
          DP: "01ebe324",
          DS: "69611282",
          DT: "32374d73",
          GO: "bb5a7925",
          IJ: "394eb3d3",
          JN: "",
          RD: "f1a03a0b",
          PC: "ce7f15d3",
          PCD: "ce7f15d3",
          PS: "31c7d276",
          QD: "1fc88ce7",
          RM: "03898272",
          RR: "b7784469",
          RS: "a6e019b6",
          TC: "11f440b1",
          WS: "fae40423",
        },
      },
    ],
  },
];

export const findChannelObj = (id) => CHANNELS.find((ch) => id === ch.value);

// The count of the layout buttons that a channel draws without a layout
// policy (libs/layoutOptions.ts). IntelliJ IDEA on Social has one more, the
// icon layout. Livestream always draws 7.
export const layoutAmountFor = (dataChannel, productValue) => {
  if (dataChannel === "livestream") return 7;
  const amount = Number(findChannelObj(dataChannel).layoutsNumber);
  return productValue === "IJ" && dataChannel === "social" ? amount + 1 : amount;
};

export const findTypeObj = (channel, type) => {
  const channelObj = CHANNELS.find((ch) => channel === ch.value);
  if (!channelObj) return undefined;
  return channelObj.types.find((t) => type === t.value);
};

// Types that remain valid for direct routes and saved scenes but must not be
// offered in content-type selectors or discovery results.
export const NON_SELECTABLE_CONTENT_TYPES = new Set(["action"]);

export const isContentTypeSelectable = (typeValue) =>
  !NON_SELECTABLE_CONTENT_TYPES.has(typeValue);

// Service types such as Releases/Action list products without representing a
// real route template, so they do not determine channel product validity.
// Hidden-but-routable types must stay included here for saved scenes.
export const IGNORED_TYPES_FOR_PRODUCT_AVAILABILITY = new Set(["action"]);

export const productCodesForChannel = (channelValue) => {
  const channelObj = findChannelObj(channelValue);
  return [
    ...new Set(
      (channelObj?.types ?? [])
        .filter((t) => !IGNORED_TYPES_FOR_PRODUCT_AVAILABILITY.has(t.value))
        .flatMap((t) => Object.keys(t.products || {}))
    ),
  ];
};

// Products a single content type declares. This is the selector's source of
// truth: the product dropdown shows exactly the products valid for the type
// you're viewing (symmetric to the type dropdown, which filters by product).
// Returns null when the type isn't found in the channel — callers fall back to
// the channel-wide set for that transient state.
export const productCodesForType = (channelValue, typeValue) => {
  const channelObj = findChannelObj(channelValue);
  const typeObj = (channelObj?.types ?? []).find((t) => t.value === typeValue);
  if (!typeObj) return null;
  return Object.keys(typeObj.products || {});
};

// Products the Product dropdown offers while you hold one type.
//
// For a content-type channel this is the type's own list: the format is the
// meaningful axis there, and a single-product format (ads AI -> JB alone) must
// not inherit the channel's largest format's products.
//
// For a stage-typed channel (`typesAreStages`, i.e. Releases) it is the whole
// channel. The two axes are independent, and the narrow list made a product
// that ships on one stage only unreachable: it was absent from every other
// stage's list, and the Stage dropdown cannot help because it filters by the
// product you already hold. Picking such a product moves the stage instead —
// onChangeProduct resolves a stage the product carries.
//
// Falls back to the channel-wide set when the type is not the channel's, which
// is the transient state during a channel switch.
export const productCodesForSelector = (channelValue, typeValue) => {
  const channelObj = findChannelObj(channelValue);
  if (channelObj?.typesAreStages) return productCodesForChannel(channelValue);
  return productCodesForType(channelValue, typeValue) ?? productCodesForChannel(channelValue);
};

// The selectable content types one product offers inside a channel, in
// declared order. Mirror image of productCodesForType: a channel's type list
// is not uniform across products (the releases channel's RC lists no IntelliJ
// IDEA), so a landing type must be checked against the product it will open
// with.
export const selectableTypeValuesForProduct = (channelValue, productValue) => {
  const channelObj = findChannelObj(channelValue);
  return (channelObj?.types ?? [])
    .filter((t) => isContentTypeSelectable(t.value))
    .filter((t) => Object.prototype.hasOwnProperty.call(t.products || {}, productValue))
    .map((t) => t.value);
};

export const isProductValidForChannel = (productValue, channelValue) => {
  if (!productValue || !channelValue) return true;
  // ALL is a synthetic selector entry, not a channel-configured product;
  // it's only ever offered on releases (whats-new set). Saved ALL scenes on
  // releases must never be rewritten to a concrete product.
  if (productValue === ALL_PRODUCT.value) return channelValue === "releases";
  const codes = productCodesForChannel(channelValue);
  // Unknown channel or one without per-product types: nothing to enforce.
  if (!codes.length) return true;
  return codes.includes(productValue);
};

export const defaultProductForChannel = (channelValue) => {
  const codes = productCodesForChannel(channelValue);
  const preferred = DEFAULT_PRODUCTS_MAPPING[channelValue];
  const code = codes.includes(preferred) ? preferred : codes[0];
  return PRODUCTS.find((p) => p.value === code) ?? DEFAULT_PRODUCT;
};
